import {
    Home,
    Users,
    CreditCard,
    Cpu,
    Settings,
    LogOut,
    List,
    Flag,
    BadgeDollarSign,
    Factory,
  } from 'lucide-react';
  import { Link, useLocation, useNavigate } from 'react-router-dom';
 
  
  const AdminLayout = ({ children }) => {
    const location = useLocation();
    const navigate = useNavigate();
  
    const navItems = [
      { name: 'Dashboard', path: '/admin', icon: <Home size={18} /> },
      { name: 'Country Management', path: '/admin/countries', icon: <Flag size={18} /> },
      { name: 'Industry Management', path: '/admin/industries', icon: <Factory size={18} /> },
      { name: 'User Management', path: '/admin/users', icon: <Users size={18} /> },
      { name: 'Category Management', path: '/admin/categories', icon: <List size={18} /> },
      { name: 'Apps Management', path: '/admin/apps', icon: <Cpu size={18} /> },
      { name: 'Plans Management', path: '/admin/plans', icon: <CreditCard size={18} /> },
      { name: 'Coupon Management', path: '/admin/coupons', icon: <BadgeDollarSign size={18} /> },
      { name: 'Billing Management', path: '/admin/billing', icon: <CreditCard size={18} /> },
      { name: 'AI Providers', path: '/admin/providers', icon: <Cpu size={18} /> },
      { name: 'Settings', path: '/admin/settings', icon: <Settings size={18} /> },
    ];
  
    const handleLogout = () => {
      localStorage.removeItem('token'); // or your auth/session logic
      navigate('/login');
    };
  
    return (
      <div className="flex min-h-screen bg-gray-100">
        <aside className="w-64 bg-white shadow-md flex flex-col justify-between">
          {/* Top logo + role section */}
          <div className="p-4">
            <div className="flex flex-col items-start mb-6">
            <img src="/ennoverse.png" alt="Ennoverse" className="h-8 mb-2" />

              <span className="text-xs text-gray-500 bg-gray-100 border border-gray-300 px-2 py-1 rounded-md">
                Logged in as Administrator
              </span>
            </div>
  
            <nav className="space-y-2">
              {navItems.map(item => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex items-center gap-2 px-3 py-2 rounded-md ${
                    location.pathname === item.path
                      ? 'bg-blue-100 text-blue-600 font-semibold'
                      : 'text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {item.icon}
                  {item.name}
                </Link>
              ))}
            </nav>
          </div>
  
          {/* Logout */}
          <div className="p-4">
            <button
              onClick={handleLogout}
              className="flex items-center gap-2 text-red-600 hover:bg-red-100 w-full px-3 py-2 rounded-md"
            >
              <LogOut size={18} />
              Logout
            </button>
          </div>
        </aside>
  
        <main className="flex-1 p-6">{children}</main>
      </div>
    );
  };
  
  export default AdminLayout;
  